import { useInfiniteQuery } from "@tanstack/react-query";
import { usePermissionModal } from "contexts/PermissionModalContext";
import pedidosCompraService, { ProdutoBusca } from "services/pedidosCompraService";

interface PageResult {
  isSuccess: boolean;
  data: ProdutoBusca[];
  total: number;
  pageIndex: number;
  pageSize: number;
  message?: string;
}

export const useBuscarProdutosPedido = (termo?: string) => {
  const { getQueryRetryHandler } = usePermissionModal();

  return useInfiniteQuery({
    queryKey: ["buscar-produtos-pedido", termo],
    queryFn: async ({ pageParam = 0 }) => {
      if (!termo || termo.trim().length < 2) {
        return {
          isSuccess: true,
          data: [],
          total: 0,
          pageIndex: 0,
          pageSize: 20,
        } as PageResult;
      }

      return await pedidosCompraService.buscarProdutos(termo, pageParam, 20);
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (!lastPage || !lastPage.isSuccess) return undefined;

      const currentPage = lastPage.pageIndex;
      const totalPages = Math.ceil(lastPage.total / lastPage.pageSize);

      return currentPage + 1 < totalPages ? currentPage + 1 : undefined;
    },
    enabled: true, // Sempre habilitado, mas retorna array vazio se termo for inválido
    retry: getQueryRetryHandler({
      queryKey: ["buscar-produtos-pedido", termo],
      defaultMessage:
        "Você não possui permissão para incluir produtos no pedido.",
    }),
    staleTime: 30000, // Cache por 30 segundos
  });
};

export type { ProdutoBusca };
